import { type FC } from 'react';
import { type EnergyAudit } from 'interfaces/EnergyAudit.interface';
import RenderBlocks from '../lists/BulletBlockList';
import SourceLinksList from 'components/links/SourceLinksList';
import { PercentageIcon } from '@components/icons/PercentageIcon';

interface EnergyAuditSubsidiesTabProps {
  data: EnergyAudit;
}

const EnergyAuditSubsidiesTab: FC<EnergyAuditSubsidiesTabProps> = ({
  data,
}) => {
  const tabData = data?.subsidies as any;
  const blocks = tabData?.blocks;
  const hasUrls =
    Array.isArray(data?.subsidies_url) && data.subsidies_url.length > 0;

  if (data && Array.isArray(blocks) && blocks.length > 0) {
    return (
      <>
        <RenderBlocks blocks={blocks} />
        {hasUrls && <SourceLinksList urlList={data.subsidies_url} />}
      </>
    );
  }

  return (
    <div className="flex flex-col gap-6 items-center justify-center text-center">
      <PercentageIcon />
      <div>
        <p className="mb-2 font-bold text-gray-60 text-base">
          No subsidies available for this project
        </p>
        <p className="max-w-[400px] leading-[150%]">
          There are currently no specific subsidies available for this
          ventilation optimization project in your region.
        </p>
      </div>
    </div>
  );
};

export default EnergyAuditSubsidiesTab;
